/** @file AppUtils.js
  * @brief Helper functions for handling small repetitive tasks
  *
  * @author Justin Eslinger - Fivestone Studios
  * @date 07/23/2020
  *
  */

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const isMobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i)

// Safari 3.0+ "[object HTMLElementConstructor]" 
export const isSafari = window.safari !== undefined;

// Apple Mobile (iPhone / iPad)
export const WebKit = !!navigator.userAgent.match(/WebKit/i);
export const isIOS = (WebKit !== 'undefined') && (!!navigator.userAgent.match(/iPad/i) || !!navigator.userAgent.match(/iPhone/i)) && WebKit;

// Internet Explorer 6-11
export const isIE = /*@cc_on!@*/false || !!document.documentMode;

export const isMediaRecorderSupported = !(window.MediaRecorder === undefined) && !isSafari;

export function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function validateInput(data) {
  if(data.match(/^[0-9a-zA-Z ']{1,32}$/)){
      return true;
  }
  else {
      return false;
  }
}

export function encodeHTML(s) {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#x27;',
      "/": '&#x2F;',
  };
  const reg = /[&<>"'/]/ig;
  return s.replace(reg, (match)=>(map[match]));
}